import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";
import {
  BlockTitle,
  Button,
  Col,
  Row,
  RSelect,
} from "../../../../components/Component";
import { GET } from "../../../../helper/api";
import { BILL_TYPE, INGREDIENT_GROUP, LOCATION, randomString, TRUCK_TYPE, USER_ROLES } from "../../../../utils/Utils";


const LOCATION_OPTIONS = Object.keys(LOCATION).map((c) => ({
  label: LOCATION[c],
  value: c,
}));

const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).filter(e => e !== 'SERVICE').map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));


const PnBillForm = ({
  id,
  driveRentalContractOptions,
  disabledForm,
}) => {
  const { errors, register, control, setValue, watch } = useFormContext();

  const fromLocation = watch("fromLocation");
  const toLocation = watch("toLocation");
  const driveRentalContractId = watch("driveRentalContractId");

  const type = watch("type");
  const driverId = watch("driverId");
  const subDriverId = watch("subDriverId");
  const isDeliveryBill = useMemo(() => (!!fromLocation && !!toLocation) || (!!driveRentalContractId), [fromLocation, toLocation, driveRentalContractId]);
  const createdAt = watch("createdAt");

  console.log(createdAt)
  const randomId = () => {
    const id = `PN-${moment().format("YYYYMMDD")}-${randomString(10)}`;
    setValue("id", id);
    return id;
  }

  const location = watch("location");

  const [driverOptions, setDriverOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [fromLocationOptions, setFromLocationOptions] = useState([]);
  const [toLocationOptions, setToLocationOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [seaportOptions, setSeaportOptions] = useState([]);

  useEffect(() => {


    GET(`/ingredient`, {}, true)
      .then(({ data }) => {
        setIngredientOptions(data.rows.filter(c => c.group === INGREDIENT_GROUP.INGREDIENT).map(c => ({
          label: `${c.name}`,
          value: c.id,
          data: c
        })))
      })


    GET("/location-distance", {}, true).then((resp) => {
      const { data } = resp;
      const fromObj = {};
      const toObj = {};
      data.forEach((c) => {
        fromObj[c.fromLocation] = c.fromLocationName;
        toObj[c.toLocation] = c.toLocationName;
      });
      setFromLocationOptions(Object.keys(fromObj).map((c) => ({
        label: fromObj[c],
        value: c,
        data: c,
      })));
      setToLocationOptions(Object.keys(toObj).map((c) => ({
        label: toObj[c],
        value: c,
        data: c,
      })));
    });

    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("/pn-new-customer-money-flow/find-all-with-balance", {}, true).then((resp) => {
      const { data } = resp;
      setCustomerOptions(
        data.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/user", {}, true).then((resp) => {
      const { data } = resp;

      setDriverOptions(
        data.filter(c => c.unit === 'DRIVER').map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/pn-seaport", {}, true).then((resp) => {
      const { data } = resp;
      setSeaportOptions(
        data.map((c) => ({
          label: `${c.name}${c.address ? ` - ${c.address}` : ''}`,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  return (
    <div>
      {disabledForm ? <div className="form-overlay"></div> : <></>}
      <div className="mb-4">
        <Row className="g-2">
          <Col size="4">
            <div className="form-group">
              <label className="form-label" htmlFor="customer">
                Mã đơn <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <InputGroup>
                  <input
                    type="text"
                    className="form-control"
                    name="id"
                    ref={register({
                      required: "Vui lòng nhập thông tin",
                    })}
                    disabled={true}
                  />
                  <InputGroupAddon addonType="append">
                    <Button disabled={!!id} type="button" color="primary" onClick={(e) => {
                      e?.preventDefault();
                      randomId();
                    }}>
                      <span>Tạo ngẫu nhiên</span>
                    </Button>
                  </InputGroupAddon>
                </InputGroup>


                <ErrorMessage
                  errors={errors}
                  name="id"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col size="3">
            <div className="form-group">
              <label className="form-label" >
                Thời gian tạo đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <input
                  rows={3}
                  className="form-control"
                  type="datetime-local"
                  name="createdAt"
                  ref={register({ required: "Vui lòng nhập thông tin" })}
                />
                <ErrorMessage
                  errors={errors}
                  name="createdAt"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="mt-3 g-2">
        <Col size={12}>
          <BlockTitle tag="h5" className={`text-primary`}>
            Thông tin địa điểm gửi nhận
          </BlockTitle>
        </Col>
        <Col size="2">
          <div className="form-group">
            <label className="form-label" >
              Nhập/Xuất H.Hoá
            </label>
            <div className="form-control-wrap">

              <Controller
                control={control}
                name="customerDirection"
                rules={{
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    placeholder="Chọn hướng"
                    isClearable
                    options={BILL_TYPE_OPTIONS}
                    value={BILL_TYPE_OPTIONS.find(e => e.value === value) || null}
                    onChange={(val) => {
                      onChange(val?.value || null)
                    }}
                  />
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="2">
          <div className="form-group">
            <label className="form-label" >
              Tên H.Hoá
            </label>
            <div className="form-control-wrap">

              <Controller
                control={control}
                name="ingredientVATName"
                render={({ onChange, value, name, ref }) => (
                  <Input value={value} onChange={(e) => onChange(e.target.value)} />
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Chọn điểm A
            </label>
            <div className="form-control-wrap">

              <Controller
                control={control}
                name="fromLocation"
                rules={{
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    placeholder="Chọn điểm A"
                    isClearable
                    options={fromLocationOptions}
                    value={fromLocationOptions.find(e => e.value === value) || null}
                    onChange={(val) => {
                      onChange(val?.value || null)
                    }}
                  />
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Chọn điểm B
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="toLocation"
                rules={{
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    placeholder="Chọn điểm B"
                    isClearable
                    options={toLocationOptions}
                    value={toLocationOptions.find(e => e.value === value) || null}
                    onChange={(val) => {
                      onChange(val?.value || null)
                    }}
                  />
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="2">
          <div className="form-group">
            <label className="form-label" >
              Hợp đồng thuê xe
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="driveRentalContractId"
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    isClearable
                    ref={ref}
                    name={name}
                    options={driveRentalContractOptions}
                    value={
                      driveRentalContractOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val?.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="driveRentalContractId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col size={12}>
          <BlockTitle tag="h5" className={`text-primary`}>
            Thông tin đơn hàng
          </BlockTitle>
        </Col>
        <Col size="3">
          <div className="form-group">
            <label className="form-label">
              Loại công nợ NCC/KH
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="type"
                rules={{
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    isClearable
                    ref={ref}
                    name={name}
                    options={BILL_TYPE_OPTIONS}
                    value={
                      BILL_TYPE_OPTIONS.find(
                        (c) => `${c.value}` === `${value}`
                      ) || null
                    }
                    onChange={(val) => {
                      onChange(val?.value || null)
                      setValue("customerId", null)
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="type"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Công nợ NCC/KH{!!type ? <>{` `}<span className="text-danger">*</span></> : ''}
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="customerId"
                rules={!!type ? {
                  required: "Vui lòng nhập thông tin"
                } : {}}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    isClearable={!type}
                    ref={ref}
                    name={name}
                    options={customerOptions.filter(c => c.data.type === type)}
                    value={
                      customerOptions.find(
                        (c) => `${c.value}` === `${value}`
                      ) || null
                    }
                    onChange={(val) => {
                      onChange(val.value)
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="customerId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Xe tải
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="truckId"
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    isClearable
                    ref={ref}
                    name={name}
                    options={truckOptions}
                    value={
                      truckOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="truckId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Nguyên liệu{` `}<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="ingredientId"
                rules={{
                  required: "Vui lòng nhập thông tin"
                }}
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={ingredientOptions}
                    value={
                      ingredientOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="ingredientId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="3" >
          <div className="form-group">
            <label className="form-label" >
              Xuất khẩu/Trong nước<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="location"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={LOCATION_OPTIONS}
                    value={
                      LOCATION_OPTIONS.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="location"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        {location === 'EXTERNAL' && (
          <Col size="3">
            <div className="form-group">
              <label className="form-label">
                Cảng biển <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="seaportId"
                  rules={{ required: "Vui lòng chọn cảng biển" }}
                  render={({ onChange, name, value, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={seaportOptions}
                      value={seaportOptions.find((c) => c.value === value) || null}
                      onChange={(val) => onChange(val?.value || null)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="seaportId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        )}
        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Khối lượng(kg)
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="finalMerchandiseWeight"
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={0}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="finalMerchandiseWeight"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col size="3">
          <div className="form-group">
            <label className="form-label" >
              Phí vận chuyển(đ)
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="deliveryFeeByWeight"
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="deliveryFeeByWeight"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="3" >
          <div className="form-group">
            <label className="form-label" >
              Phí vận chuyển xuất khẩu(đ)
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="deliveryFeeExternal"
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="deliveryFeeExternal"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>


        <Col size="12">
          <div className="form-group">
            <label className="form-label" >
              Ghi chú
            </label>
            <div className="form-control-wrap">
              <textarea
                rows={3}
                className="form-control"
                style={{ height: "unset" }}
                name="note"
                ref={register()}
              />
            </div>
          </div>
        </Col>
      </Row>
      {isDeliveryBill && <>
        <Row className="mt-3">
          <Col size={12}>
            <BlockTitle tag="h5" className={`text-primary`}>
              Thông tin Tiền thưởng tài xế
            </BlockTitle>
          </Col>
          <Col size="3">
            <div className="form-group">
              <label className="form-label" >
                Tài xế
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="driverId"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={driverOptions}
                      value={driverOptions.find((c) => c.value === value) || null}
                      onChange={(val) => {
                        onChange(val?.value || "");
                        setValue("driverBonus", 0);
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>



          <Col size="3">
            <div className="form-group">
              <label className="form-label" >
                Tiền tài chính(đ){!!driverId ? <>{` `}<span className="text-danger">*</span></> : ''}
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="driverBonus"
                  rules={!!driverId ? { required: "Vui lòng nhập thông tin" } : {}}
                  render={({ onChange, value, ref }) => (
                    <NumericFormat
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="driverBonus"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col size="3">
            <div className="form-group">
              <label className="form-label" >
                Tài phụ
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="subDriverId"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={driverOptions}
                      value={driverOptions.find((c) => c.value === value) || null}
                      onChange={(val) => {
                        onChange(val?.value || '');
                        setValue("subDriverBonus", 0);
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col size="3">
            <div className="form-group">
              <label className="form-label" >
                Tiền tài phụ(đ){!!subDriverId ? <>{` `}<span className="text-danger">*</span></> : ''}
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="subDriverBonus"
                  rules={!!subDriverId ? { required: "Vui lòng nhập thông tin" } : {}}
                  render={({ onChange, value, ref }) => (
                    <NumericFormat
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="subDriverBonus"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>

      </>}
    </div>
  )
}

export default PnBillForm;